export default __webpack_public_path__ + "static/media/play-circle-24px.9e69f854.svg";